<template>
  <div class="question-new">
    <Row :gutter="16">
      <i-col span="18">
        <Form ref="newForm" :model="model"
          :rules="modelValidate"
          label-position="left"
          :label-width="140">
          <FormItem label="名称" prop="name">
            <Input v-model="model.name" placeholder="输入名称" />
          </FormItem>
          <FormItem label="标题" prop="title">
            <Input v-model="model.title" placeholder="输入名称" />
          </FormItem>
          <FormItem label="类型" prop="type">
            <Select v-model="model.type" filterable>
              <Option v-for="(tp,idx) in $common.getEnumSelect($common.appraisalQuestionType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
            </Select>
          </FormItem>
          <FormItem label="增加附加选项" prop="needExtInfo"
            v-if="[0,1].indexOf(model.type)>=0">
            <i-switch v-model="model.needExtInfo"></i-switch>
          </FormItem>
          <FormItem label="增加附加输入项" prop="needExtInput"
            v-if="[0,1].indexOf(model.type)>=0">
            <i-switch v-model="model.needExtInput"></i-switch>
          </FormItem>
          <FormItem label="选择项" prop="options"
            v-if="[0,1].indexOf(model.type)>=0&&model.needExtInfo">
            <div class="question-select">
              <div class="question-select-item" v-for="(opt,optIdx) in model.options" :key="optIdx">
                <FormItem label="选中值" :label-width="80" label-position="right"
                  :prop="`options[${optIdx}].value`"
                  :rules="[{required:true,type:'number',message:'请输入',trigger:'blur'}]" class="inline-form-item">
                  <Input disabled v-model="opt.value" placeholder="输入选项选中对应值" style="width:80px" />
                </FormItem>
                <FormItem label="选项" :label-width="80" label-position="right"
                  :prop="`options[${optIdx}].label`"
                  :rules="[{required:true,message:'请输入',trigger:'blur'}]" class="inline-form-item" style="flex:1">
                  <Input v-model="opt.label" placeholder="输入选项显示内容" style="width:100%" />
                </FormItem>
                <FormItem class="inline-form-item">
                  <Button shape="circle" ghost icon="md-remove" type="error" @click="removeOption(opt)"></Button>
                </FormItem>
              </div>
              <Button long ghost type="primary" icon="md-add" @click="addOption">增加选项</Button>
            </div>
          </FormItem>
          <FormItem label="附加输入项" prop="options"
            v-if="[0,1].indexOf(model.type)>=0&&model.needExtInput">
            <div class="question-select">
              <div class="question-select-item" v-for="(opt,optIdx) in model.options" :key="optIdx">
                <FormItem label="类型" :label-width="160" label-position="right"
                  :prop="`options[${optIdx}].type`"
                  :rules="[{required:true,message:'请输入',trigger:'blur'}]" class="inline-form-item">
                  <Select v-model="opt.type" placeholder="选择类型" style="width:200px">
                    <Option value="number" selected>数值</Option>
                    <Option value="text">文本</Option>
                  </Select>
                </FormItem>
                <FormItem label="标题" :label-width="160" label-position="right"
                  :prop="`options[${optIdx}].label`"
                  :rules="[{required:true,message:'请输入',trigger:'blur'}]" class="inline-form-item" style="flex:1">
                  <Input v-model="opt.label" placeholder="输入项标题" />
                </FormItem>
                <FormItem label="默认值" :label-width="160" label-position="right"
                  :prop="`options[${optIdx}].defaultValue`">
                  <InputNumber v-model="opt.defaultValue" v-if="'number'===opt.type"
                    placeholder="输入默认值" />
                  <Input v-model="opt.defaultValue" v-else-if="'text'===opt.type"
                    placeholder="输入默认值" />
                </FormItem>
                <FormItem class="inline-form-item">
                  <Button shape="circle" ghost icon="md-remove" type="error" @click="removeType1Option(opt)"></Button>
                </FormItem>
              </div>
              <Button long ghost type="primary" icon="md-add" @click="addType1Option">增加选项</Button>
            </div>
          </FormItem>
          <FormItem label="选择项" prop="options"
            v-if="[6].indexOf(model.type)>=0">
            <div class="question-select">
              <div class="question-select-item" v-for="(opt,optIdx) in model.options" :key="optIdx">
                <FormItem label="选中值" :label-width="80" label-position="right"
                  :prop="`options[${optIdx}].value`"
                  :rules="[{required:true,type:'number',message:'请输入',trigger:'blur'}]" class="inline-form-item">
                  <Input disabled v-model="opt.value" placeholder="输入选项选中对应值" style="width:80px" />
                </FormItem>
                <FormItem label="选项" :label-width="80" label-position="right"
                  :prop="`options[${optIdx}].label`"
                  :rules="[{required:true,message:'请输入',trigger:'blur'}]" class="inline-form-item" style="flex:1">
                  <Input v-model="opt.label" placeholder="输入选项显示内容" style="width:100%" />
                </FormItem>
                <FormItem class="inline-form-item">
                  <Button shape="circle" ghost icon="md-remove" type="error" @click="removeOption(opt)"></Button>
                </FormItem>
              </div>
              <Button long ghost type="primary" icon="md-add" @click="addOption">增加选项</Button>
            </div>
          </FormItem>
          <FormItem label="分类设置" prop="options"
            v-if="[7].indexOf(model.type)>=0">
            <div class="question-select">
              <div class="question-select-item" v-for="(opt,optIdx) in model.options" :key="optIdx">
                <FormItem label="序号" :label-width="80" label-position="right"
                  :prop="`options[${optIdx}].value`"
                  :rules="[{required:true,message:'请输入',trigger:'blur'}]" class="inline-form-item">
                  <Input disabled v-model="opt.value" placeholder="输入选项选中对应值" style="width:80px" />
                </FormItem>
                <FormItem label="分类名称" :label-width="80" label-position="right"
                  :prop="`options[${optIdx}].label`"
                  :rules="[{required:true,message:'请输入',trigger:'blur'}]" class="inline-form-item" style="flex:1">
                  <Input v-model="opt.label" placeholder="输入选项显示内容" style="width:100%" />
                </FormItem>
                <FormItem label="需要详情" :label-width="80" label-position="right"
                  :prop="`options[${optIdx}].needDetail`" class="inline-form-item">
                  <i-switch v-model="opt.needDetail" />
                </FormItem>
                <FormItem class="inline-form-item">
                  <Button shape="circle" ghost icon="md-remove" type="error" @click="removeType7Option(opt)"></Button>
                </FormItem>
              </div>
              <Button long ghost type="primary" icon="md-add" @click="addType7Option">增加选项</Button>
            </div>
          </FormItem>
          <FormItem label="上传文件设置" prop="options"
            v-if="[5].indexOf(model.type)>=0">
            <FormItem label="类型" :label-width="160" label-position="right"
              prop="options.formats"
              :rules="[{required:true,message:'请输入',trigger:'blur'}]" class="inline-form-item">
              <Input v-model="model.options.formats" placeholder="输入文件类型" style="width:200px" />
            </FormItem>
            <FormItem label="文件大小限制(KB)" :label-width="160" label-position="right"
              prop="options.sizeLimit"
              :rules="[{required:true,type:'number',message:'请输入',trigger:'blur'}]" class="inline-form-item" style="flex:1">
              <InputNumber v-model="model.options.sizeLimit" placeholder="输入文件大小限制(KB)，0代表不限制" />
            </FormItem>
            <FormItem label="支持多个文件" :label-width="160" label-position="right"
              prop="options.multiple" class="inline-form-item">
              <i-switch v-model="model.options.multiple" />
            </FormItem>
          </FormItem>
          <FormItem label="说明信息" prop="description">
            <Input type="textarea" v-model="model.description" placeholder="说明信息包括填写规范、评分方法等" />
          </FormItem>
          <FormItem label="默认值" prop="defaultValue">
            <Input v-model="model.defaultValue" placeholder="输入默认值" />
          </FormItem>
          <FormItem label="是否必填" prop="isRequired">
            <i-switch v-model="model.isRequired"></i-switch>
          </FormItem>
          <FormItem label="评分表达式" prop="scoreFormula">
            <Input v-model="model.scoreFormula" placeholder="输入评分表达式" />
            <span><a href="https://mathjs.org/docs/expressions/syntax.html" target="_blank">https://mathjs.org/docs/expressions/syntax.html</a></span>
          </FormItem>
          <FormItem label="是否需要补充详情" prop="needDetail" v-if="[3,4].indexOf(model.type)>=0">
            <i-switch v-model="model.needDetail"></i-switch>
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from '../../api/Api.js'
export default {
  name: 'question-new',
  props: {
  },
  data () {
    return {
      loading: false,
      model: {
        name: null,
        title: null,
        type: null,
        description: null,
        defaultValue: null,
        scoreFormula: null,
        needDetail: false,
        needExtInfo: false,
        needExtInput: false,
        extInfo: null,
        options: [],
        isRequired: true
      },
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请填写标题', trigger: 'blur' }
        ],
        type: [
          { required: true, type: 'number', message: '请选择', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    'model.type': function (newVal) {
      if (newVal === 6) {
        this.model.options = [
          {label: '', value: 0},
          {label: '', value: 1},
          {label: '', value: 2}
        ]
      } else if (newVal === 7) {
        this.model.options = [
          { value: 'C0', label: '', needDetail: true },
          { value: 'C1', label: '', needDetail: true },
          { value: 'C2', label: '', needDetail: true }
        ]
      } else if (newVal === 5) {
        this.model.options = {
          formats: 'pdf,jpg,jpeg,png',
          sizeLimit: 10240,
          multiple: true
        }
      }
    },
    'model.needExtInfo': function (newVal) {
      if (newVal) {
        this.model.needExtInput = false
        if ([0, 1].indexOf(this.model.type) >= 0) {
          this.model.options = [
            {label: '', value: 0},
            {label: '', value: 1},
            {label: '', value: 2}
          ]
        }
      }
    },
    'model.needExtInput': function (newVal) {
      if (newVal) {
        this.model.needExtInfo = false
        if ([0, 1].indexOf(this.model.type) >= 0) {
          this.model.options = [{
            type: 'number',
            label: '',
            defaultValue: 0,
            value: null
          }]
        }
      }
    }
  },
  mounted () {
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    adjustSeq () {
      this.model.options.forEach((opt, idx) => {
        opt.value = idx
      })
    },
    addOption () {
      if (!this.model.options || !(this.model.options instanceof Array)) {
        this.model.options = []
      }
      this.model.options.push({
        label: '',
        value: this.model.options.length
      })
      this.adjustSeq()
    },
    removeOption (option) {
      let idx = this.model.options.findIndex(o => o === option)
      this.model.options.splice(idx, 1)
      this.adjustSeq()
    },
    addType1Option () {
      if (!this.model.options || !(this.model.options instanceof Array)) {
        this.model.options = []
      }
      this.model.options.push({
        type: 'number',
        label: '',
        defaultValue: 0,
        value: null
      })
    },
    removeType1Option (option) {
      let idx = this.model.options.findIndex(o => o === option)
      this.model.options.splice(idx, 1)
    },
    adjustType7Seq () {
      this.model.options.forEach((opt, idx) => {
        opt.value = 'C' + idx
      })
    },
    addType7Option () {
      if (!this.model.options || !(this.model.options instanceof Array)) {
        this.model.options = []
      }
      this.model.options.push({
        label: '',
        value: 'C' + this.model.options.length,
        needDetail: true
      })
      this.adjustType7Seq()
    },
    removeType7Option (option) {
      let idx = this.model.options.findIndex(o => o === option)
      this.model.options.splice(idx, 1)
      this.adjustType7Seq()
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          if ([0, 1, 5, 6, 7].indexOf(this.model.type) >= 0) {
            if ([0, 1].indexOf(this.model.type) >= 0 && !this.model.needExtInfo && !this.model.needExtInput) {
              this.model.extInfo = null
            } else {
              let options = JSON.stringify(this.model.options)
              this.model.extInfo = options
            }
          }
          await Api.Appraisal.addAppraisalQuestion(this.model)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('新增成功!')
              this.model= {
                name: null,
                title: null,
                type: null,
                description: null,
                defaultValue: null,
                scoreFormula: null,
                needDetail: false,
                needExtInfo: false,
                needExtInput: false,
                extInfo: null,
                options: [],
                isRequired: true
              }
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.question-select {
  width: 100%;
}
.question-select-item {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

</style>
